export interface SearchRadiusOption {
  label: string;
  value: number | null;
}

/**
 * Ordered search-radius options. The slider index maps 1:1 to this array.
 * The `null` value (last option) means "no limit" and is omitted from the payload.
 */
export const SEARCH_RADIUS_OPTIONS: SearchRadiusOption[] = [
  { label: '30km', value: 30 },
  { label: '50km', value: 50 },
  { label: '75km', value: 75 },
  { label: '100km', value: 100 },
  { label: 'Sin límite', value: null },
];

/** Default selected value when the form is initialized. */
export const SEARCH_RADIUS_DEFAULT_VALUE = 75;

export const SEARCH_RADIUS_NEEDED_ACTION_VALUE = 'expand_search_radius' as const;
